import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

const WebshopPromo = () => {
    const params = useParams();
    const companyId = params.id ?? "";
    const { companySaleCheck } = useCompanySaleCheck();

    if (companyId === "" || companySaleCheck[companyId] === undefined || !companySaleCheck[companyId].allowed)
        return null;

    return (
        <div className="card mt-4 border border-primary" style={{ borderWidth: '2px' }}>
            <div className="card-header">
                <h2 className="fs-5">Legg til ekstra informasjon om bedriften</h2>
            </div>
            <div className="card-body">
                <Link to={`${UrlPath.Account.WebShopBase}/${companyId}`}><img src="/min-bedrift-ill-ekstra.svg" width="800" height="658" alt="" className="cc-card-shop-promo-ill" style={{ width: "160px" }}></img></Link>
                <p>Legg til logo, beskrivelse av bedriftens virksomhet og ekstra lenker til dine viktigste nettsider.</p>
                <p className="mb-0"><b><Link to={`${UrlPath.Account.WebShopBase}/${companyId}`}
                    key={companyId}>
                    Legg til ekstra informasjon om bedriften
                </Link></b></p>
            </div>
        </div>
    )
}

export default WebshopPromo;